import Vue from 'vue'
import SupportChat from '../components/support/SupportComponent';

const chat = new Vue({
  el: '#support',
  components:{
    SupportChat
  }
});





// WEBPACK FOOTER //
// ./resources/js/support/chat.js